<template>
<span>
    <span v-for="(subwayList, index) in subwayTrafficShowData" :key="index">
        <span class="subway" :class="getClassName(subway)" :key="`__TRAFFIC__${index}`" v-for="(subway, index) in subwayList">
            {{index === subwayList.length -1 ? subway.intro : ''}}
        </span>
    </span>
</span>
</template>

<script>
export default {
    name: 'SubwayInfo',
    props: {
        traffic: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            classList: [],
            subwayTrafficShowData: {}
        }
    },
    watch: {
        traffic: {
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.setTrafficData()
                }
            },
            deep: true
        }
    },
    computed: {
        getClassList() {
            return this.classList
        }
    },
    methods: {
        getClassName(traffic) {
            const classList = []
            const classItem = {}
            let className
            switch (traffic.station_number) {
                case "인천1":
                    className = " incheon1";
                    break;
                case "인천2":
                    className = " incheon2";
                    break;
                case "분당":
                    className = " bundang";
                    break;
                case "신분당":
                    className = " sinbundang";
                    break;
                case "경의중앙":
                    className = " jungang";
                    break;
                case "공항철도":
                    className = " airport";
                    break;
                case "경춘":
                    className = " kyeongchun";
                    break;
                case "의정부":
                    className = " uijeongbu";
                    break;
                case "용인":
                    className = " yongin";
                    break;
                case "경강":
                    className = " kyeonggang";
                    break;
                case "우이신설":
                    className = " ui";
                    break;
                case "서해":
                    className = " seohae";
                    break;
                case "김포골드":
                    className = " gimpo";
                    break;
                case "신림":
                    className = " sillim";
                    break;
                default:
                    className = traffic.station_number
                    break
            }

            classItem[`line${className}`] = 1
            classList.push(classItem)

            return classList
        },
        setTrafficData() {
            const trafficData = {}

            this.traffic.map(subway => {
                const subwayNumberToken = subway.station_number.split(',')

                if (!trafficData[subway.intro]) {
                    trafficData[subway.intro] = []
                }

                if (subwayNumberToken.length > 1) {
                    subwayNumberToken.map(numberToken => {
                        trafficData[subway.intro].push({
                            intro: subway.intro,
                            station_number: numberToken
                        })
                    })
                } else {
                    trafficData[subway.intro].push(subway)
                }
            })
            if (trafficData.length > 1) {
                console.log(trafficData)
            }
            this.subwayTrafficShowData = trafficData
        }
    }
}
</script>

<style scoped>

</style>
